import { constant } from "../constant";

const initialState = {
  loading: false,
  result: [],
  errMsg: "",
  count: 0,
};

const InstructorAvailabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.GET_INSTRUCTOR_AVAILABLITY:
      return {
        ...state,
        loading: true,
      };
    case constant.GET_INSTRUCTOR_AVAILABLITY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.result,
        errMsg: "",
      };

    case constant.GET_INSTRUCTOR_AVAILABLITY_FAILED:
      return {
        ...state,
        loading: false,
        result: [],
        errMsg: action.errMsg,
      };
    case constant.CLEAN_INSTRUCTOR_AVAILABLITY:
      return {
        ...state,
        loading: false,
        result: [],
        count: 0,
        errMsg: "",
      };
    default:
      return state;
  }
};

export default InstructorAvailabilityReducer;
